import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const previousMonthDefaults = (): { from: string; to: string } => {
  const today = new Date();
  const firstOfThisMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastOfLastMonth = new Date(firstOfThisMonth.getTime() - 86400000);
  const firstOfLastMonth = new Date(lastOfLastMonth.getFullYear(), lastOfLastMonth.getMonth(), 1);
  const fmt = (d: Date) => d.toISOString().slice(0, 10);
  return { from: fmt(firstOfLastMonth), to: fmt(lastOfLastMonth) };
};

const MonthlyCampaignProfilesAccordionItem: React.FC = () => {
  const navigate = useNavigate();
  const defaults = previousMonthDefaults();
  const [fromDate, setFromDate] = useState(defaults.from);
  const [toDate, setToDate] = useState(defaults.to);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (fromDate) params.set('from_date', fromDate);
    if (toDate) params.set('to_date', toDate);
    navigate(`/reports/predefined/monthly-campaign-profiles/results?${params.toString()}`);
  };

  return (
    <div className='flex h-full w-full flex-col rounded-sm border border-stroke bg-white px-7.5 py-5 shadow-default'>
      <h4 className='text-title-xsm font-bold sm:text-title-md'>Monthly Campaign Profiles</h4>
      <p className='mt-2 text-sm text-body'>
        Open campaigns funded within a date range. Defaults to the previous calendar month.
      </p>
      <form onSubmit={handleSubmit} className='mt-4 flex flex-1 flex-col'>
        <div className='flex flex-col gap-4 sm:flex-row'>
          <div>
            <label className='block text-[12px] font-bold mb-1'>From</label>
            <input
              type='date'
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className='h-10 rounded border border-gray-400 px-3 text-sm'
            />
          </div>
          <div>
            <label className='block text-[12px] font-bold mb-1'>To</label>
            <input
              type='date'
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              className='h-10 rounded border border-gray-400 px-3 text-sm'
            />
          </div>
        </div>
        <div className='mt-auto pt-6'>
          <button type='submit' className='rounded-lg bg-primary px-8 py-3 text-sm font-medium text-white'>
            Run report
          </button>
        </div>
      </form>
    </div>
  );
};

export default MonthlyCampaignProfilesAccordionItem;
